export default __webpack_public_path__ + "static/media/sensor.7fd7d3db.svg";